#import "../../../../../common/graphql/EntityUserMessageFields.graphql"

query PurchaseOrderMessage(
  $id: UUID!
  $first: Int
  $after: Cursor
  $filter: UserMessageFilter
) {
  purchaseOrder(id: $id) {
    id
    userMessagesByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
      filter: $filter
    ) {
      nodes {
        ...EntityUserMessageFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
